<template>
  <div class="wap-edit-panel">
    <Teleport to="#preview-button">
      <ButtonPreview
        ref="previewButton"
        :key="indexItem"
        :button="button"
        :style="styleButtonPreview"
        :index-item="indexItem" />
    </Teleport>
    <div class="row-wrapper">
      <div v-if="IS_SETTING_ICON_IN_BUTTON" class="mb-2">
        <div class="gf_panel__wrap-row">
          <div class="setting-left">Variant</div>
          <div class="setting-right">
            <GfDropdown
              b-class="btn-dropdown-class"
              f-type="simple"
              :options="BUTTON_STYLE"
              :value="(button as any).value.buttonStyle"
              @selected="(button as any).value.buttonStyle = $event.value" />
          </div>
        </div>
        <template v-if="isUseVarianIcon">
          <div class="gf_panel__wrap-row">
            <div class="setting-left">Icon</div>
            <div class="setting-right box-icon-picker">
              <div
                v-tooltip.top="'Click to change icon'"
                class="wrap-icon-setting"
                @click="onToggleIconPicker"
                @mouseover="isOpenTooltip = true"
                @mouseleave="isOpenTooltip = false">
                <span class="icon-selected" v-html="displayIcon"></span>
              </div>
              <GfIconPicker v-if="isOpenIconPicker" class="icon-picker" @on-select-icon="onSelectIcon" />
            </div>
          </div>
          <div
            v-if="(button as any).value.buttonStyle === ICON_TEXT_BUTTON"
            class="gf_panel__wrap-row gf_panel-position">
            <div class="fix-icon-left setting-left">Icon Position</div>
            <div class="fix-icon-right setting-right">
              <div class="wrap-icon-radio">
                <GfSegment
                  :value="(button as any).value.iconPosition ? (button as any).value.iconPosition : 'before'"
                  @on-change="onSelectIconPosition" />
              </div>
            </div>
          </div>
        </template>
      </div>

      <div class="gf_panel__wrap-row mb-2 flex-row">
        <div class="setting-left">
          <div class="text-style-format">
            Text Style for Button Size
            <svg
              v-tooltip="{
                placement: 'top',
                content: $t('sidebarGS.styleDetail.button.textStyleTooltip'),
                class: 'width-182',
              }"
              class="ml-4px"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @mouseover="
                isOpenTooltip = true;
                widthTooltip = '182px';
              "
              @mouseleave="
                isOpenTooltip = false;
                widthTooltip = 'auto';
              ">
              <path
                d="M8.02311 5C7.36526 5 6.85645 5.45433 6.85645 6.16635C6.85645 6.44249 6.63259 6.66635 6.35645 6.66635C6.0803 6.66635 5.85645 6.44249 5.85645 6.16635C5.85645 4.86625 6.84946 4 8.02311 4C9.24842 4 10.2701 4.87515 10.2701 6.16635C10.2701 6.63873 10.0723 7.03866 9.8485 7.34916C9.62544 7.65868 9.34929 7.91638 9.13981 8.10543C8.6614 8.53716 8.52343 9.01099 8.52344 9.49999C8.52344 9.77613 8.29959 9.99999 8.02345 10C7.74731 10 7.52344 9.77616 7.52344 9.50001C7.52342 8.7814 7.74469 8.01744 8.46985 7.36303C8.67483 7.17805 8.88129 6.98088 9.03722 6.7645C9.19246 6.54909 9.27006 6.3521 9.27006 6.16635C9.27006 5.48981 8.76064 5 8.02311 5Z"
                fill="#E2E2E2" />
              <path
                d="M8.02344 11C7.74729 11 7.52344 11.2239 7.52344 11.5C7.52344 11.7761 7.74729 12 8.02344 12C8.29958 12 8.52344 11.7761 8.52344 11.5C8.52344 11.2239 8.29958 11 8.02344 11Z"
                fill="#E2E2E2" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z"
                fill="#E2E2E2" />
            </svg>
          </div>
        </div>
        <div class="wrap-text-style">
          <div class="gf_panel__wrap-row">
            <div class="left-col">
              Large
              <svg
                v-tooltip.top="{
                  placement: 'top',
                  content: $t('sidebarGS.styleDetail.button.textStyleDefaultTooltip'),
                }"
                class="ml-4px"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @mouseover="
                  isOpenTooltip = true;
                  widthTooltip = '182px';
                "
                @mouseleave="
                  isOpenTooltip = false;
                  widthTooltip = 'auto';
                ">
                <path
                  d="M8.02311 5C7.36526 5 6.85645 5.45433 6.85645 6.16635C6.85645 6.44249 6.63259 6.66635 6.35645 6.66635C6.0803 6.66635 5.85645 6.44249 5.85645 6.16635C5.85645 4.86625 6.84946 4 8.02311 4C9.24842 4 10.2701 4.87515 10.2701 6.16635C10.2701 6.63873 10.0723 7.03866 9.8485 7.34916C9.62544 7.65868 9.34929 7.91638 9.13981 8.10543C8.6614 8.53716 8.52343 9.01099 8.52344 9.49999C8.52344 9.77613 8.29959 9.99999 8.02345 10C7.74731 10 7.52344 9.77616 7.52344 9.50001C7.52342 8.7814 7.74469 8.01744 8.46985 7.36303C8.67483 7.17805 8.88129 6.98088 9.03722 6.7645C9.19246 6.54909 9.27006 6.3521 9.27006 6.16635C9.27006 5.48981 8.76064 5 8.02311 5Z"
                  fill="#E2E2E2" />
                <path
                  d="M8.02344 11C7.74729 11 7.52344 11.2239 7.52344 11.5C7.52344 11.7761 7.74729 12 8.02344 12C8.29958 12 8.52344 11.7761 8.52344 11.5C8.52344 11.2239 8.29958 11 8.02344 11Z"
                  fill="#E2E2E2" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2Z"
                  fill="#E2E2E2" />
              </svg>
            </div>
            <div class="right-col">
              <GfDropdown
                b-class="btn-dropdown-class"
                f-type="simple"
                :is-scroll-dropdown="isScrollDropdown"
                :options="textStyles"
                :value="(button as any).value.textStyle.large"
                @selected="onSelectTextStyle($event, 'large')"
                @handle-edit="onHandleEditTextStyle" />
            </div>
          </div>
          <div class="gf_panel__wrap-row">
            <div class="left-col">Medium</div>
            <div class="right-col">
              <GfDropdown
                b-class="btn-dropdown-class"
                f-type="simple"
                :options="textStyles"
                :is-scroll-dropdown="isScrollDropdown"
                :value="(button as any).value.textStyle.medium"
                @selected="onSelectTextStyle($event, 'medium')"
                @handle-edit="onHandleEditTextStyle" />
            </div>
          </div>
          <div class="gf_panel__wrap-row">
            <div class="left-col">Small</div>
            <div class="right-col">
              <GfDropdown
                b-class="btn-dropdown-class"
                f-type="simple"
                :options="textStyles"
                :is-scroll-dropdown="isScrollDropdown"
                :value="(button as any).value.textStyle.small"
                @selected="onSelectTextStyle($event, 'small')"
                @handle-edit="onHandleEditTextStyle" />
            </div>
          </div>
        </div>
        <Teleport to="#text-advance-setting">
          <div :style="styleTextStyleSetting">
            <TextAdvancedSetting
              v-if="isShowAdvanceSetting"
              :is-advance-setting="isShowAdvanceSetting"
              :item="selectedTextStyle"
              @click-away="textAdvanceClickAway"
              @on-change-text-item="onChangTextItem"
              @on-close-advanced-setting="onCloseAdvancedSetting" />
          </div>
        </Teleport>
      </div>

      <div class="mb-2">
        <div class="gf_panel__wrap-row">
          <div class="setting-left">Border</div>
          <div class="setting-right">
            <GfDropdown
              b-class="btn-dropdown-class"
              f-type="simple"
              :options="borders"
              :is-scroll-dropdown="isScrollDropdown"
              :value="(button as any).value.borderStyle"
              @selected="onSelectBorderStyle"
              @handle-edit="onHandleEditBorderStyle" />
          </div>
        </div>
        <div class="gf_panel__wrap-row">
          <div class="setting-left">Corner</div>
          <div class="setting-right">
            <GfDropdown
              b-class="btn-dropdown-class"
              f-type="simple"
              :options="corners"
              :is-scroll-dropdown="isScrollDropdown"
              :value="(button as any).value.cornerStyle"
              @selected="onSelectCornerStyle"
              @handle-edit="onHandleEditCornerStyle" />
          </div>
        </div>
        <div>
          <div class="gf_panel__wrap-row">
            <div class="setting-left">Dropshadow</div>
            <div class="setting-right">
              <GfToggle :checked="!!(button as any).value.dropShadow.enabled" @on-change="toggleSettingDropshadow" />
            </div>
          </div>
          <div v-if="!!(button as any).value.dropShadow.enabled" class="setting-dropshadow">
            <div class="d-flex setting-dropshadow_item-color">
              <div>Color</div>
              <div class="demo-color-picker" @click="onShowColorPickerDropShadow">
                <div
                  class="demo-color-picker--box"
                  :style="{
                    background: getBackgroundColor((button as any).value.dropShadow && (button as any).value.dropShadow.color),
                  }"></div>
              </div>
              <div v-if="showColorPickerDropShadow" class="color--picker" :style="styleColorPicker">
                <GfColorPicker
                  :color="(button as any).value.dropShadow.color"
                  @cancel="onCancelColorPicker"
                  @out-size="onCancelColorPicker"
                  @apply="onApplyColorPicker"
                  @change-color="onApplyColorPicker" />
              </div>
            </div>
            <div class="setting-dropshadow--distance">
              <div class="d-flex align-items-center justify-content-between setting-dropshadow_item--first mr-1">
                <div class="">Distance</div>
                <div class="setting-dropshadow_input">
                  <GfInputUnit
                    :units="pxInputUnit"
                    unit-class="setting-dropshadow_input--unit-class"
                    :value="getValueWithDataUnit((button as any).value.dropShadow.distance).value"
                    @on-change="onChangeDistanceDropshadow" />
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between setting-dropshadow_item--second">
                <div class="">Blur</div>
                <div class="setting-dropshadow_input">
                  <GfInputUnit
                    :units="pxInputUnit"
                    unit-class="setting-dropshadow_input--unit-class"
                    :min="0"
                    :value="getValueWithDataUnit((button as any).value.dropShadow.blur).value"
                    @on-change="onChangeBlurDropshadow" />
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="d-flex align-items-center justify-content-between setting-dropshadow_item--first mr-1">
                <div class="">Angle</div>
                <div class="setting-dropshadow_input">
                  <GfInputUnit
                    :units="degInputUnit"
                    unit-class="setting-dropshadow_input--unit-class"
                    :value="getValueWithDataUnit((button as any).value.dropShadow.angle).value"
                    @on-change="onChangeAngleDropshadow" />
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between setting-dropshadow_item--second">
                <div class="">Size</div>
                <div class="setting-dropshadow_input">
                  <GfInputUnit
                    :units="pxInputUnit"
                    unit-class="setting-dropshadow_input--unit-class"
                    :value="getValueWithDataUnit((button as any).value.dropShadow.size).value"
                    @on-change="onChangeSizeDropshadow" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-pack-color">
        <template v-if="isUseVarianOnlyText">
          <div class="title-pack-color mb-1">Text Color</div>
          <div class="gf_panel__wrap-row">
            <div class="left">
              <div class="wrap-choose-color">
                <div class="color-col-left">
                  <div class="lbl">Default</div>
                </div>
                <div class="color-col-right">
                  <ColorItem
                    v-tooltip.top="'Click to change color'"
                    :is-active="isCurrentChangeColor('text', 'text_origin')"
                    :color="(button as any).value.textColor.origin"
                    :is-can-change-color="true"
                    @click="onShowColorPalette('text', 'text_origin')" />
                </div>
              </div>
            </div>
            <div class="right">
              <div class="wrap-choose-color">
                <div class="color-col-left">
                  <div class="lbl">Hover</div>
                </div>
                <div class="color-col-right">
                  <ColorItem
                    v-tooltip.top="'Click to change color'"
                    :is-active="isCurrentChangeColor('text', 'text_hover')"
                    :color="(button as any).value.textColor.hover"
                    :is-can-change-color="true"
                    @click="onShowColorPalette('text', 'text_hover')" />
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="isUseVarianIcon">
          <div class="title-pack-color">Icon Color</div>
          <div class="gf_panel__wrap-row">
            <div class="left">
              <div class="wrap-choose-color">
                <div class="color-col-left">
                  <div class="lbl">Default</div>
                </div>
                <div class="color-col-right">
                  <ColorItem
                    v-tooltip.top="'Click to change color'"
                    :is-active="isCurrentChangeColor('icon', 'icon_origin')"
                    :color="(button as any).value.iconColor.origin"
                    :is-can-change-color="true"
                    @click="onShowColorPalette('icon', 'icon_origin')" />
                </div>
              </div>
            </div>
            <div class="right">
              <div class="wrap-choose-color">
                <div class="color-col-left">
                  <div class="lbl">Hover</div>
                </div>
                <div class="color-col-right">
                  <ColorItem
                    v-tooltip.top="'Click to change color'"
                    :is-active="isCurrentChangeColor('icon', 'icon_hover')"
                    :color="(button as any).value.iconColor.hover"
                    :is-can-change-color="true"
                    @click="onShowColorPalette('icon', 'icon_hover')" />
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- <template> -->
        <div class="title-pack-color">Background Color</div>
        <div class="gf_panel__wrap-row">
          <div class="left">
            <div class="wrap-choose-color">
              <div class="color-col-left">
                <div class="lbl">Default</div>
              </div>
              <div class="color-col-right">
                <ColorItem
                  v-tooltip.top="'Click to change color'"
                  :is-active="isCurrentChangeColor('background', 'background_origin')"
                  :color="(button as any).value.backgroundColor.origin"
                  :is-can-change-color="true"
                  @click="onShowColorPalette('background', 'background_origin')" />
              </div>
            </div>
          </div>
          <div class="right">
            <div class="wrap-choose-color">
              <div class="color-col-left">
                <div class="lbl">Hover</div>
              </div>
              <div class="color-col-right">
                <ColorItem
                  v-tooltip.top="'Click to change color'"
                  :is-active="isCurrentChangeColor('background', 'background_hover')"
                  :color="(button as any).value.backgroundColor.hover"
                  :is-can-change-color="true"
                  @click="onShowColorPalette('background', 'background_hover')" />
              </div>
            </div>
          </div>
        </div>
        <!-- </template> -->
        <div v-if="showColorPalette" class="color--palette" :style="styleColorPalette">
          <GfColorPalette
            :color="selectedColor"
            @pick-color="onApplyColorPalette"
            @edit-color-style="onEditColorStyle"
            @on-close-pallete="showColorPalette = false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import GfDropdown from '@/core/components/base/GfDropdown.vue';
import GfSegment from '@/core/components/base/GfSegment.vue';
import ButtonPreview from './/ButtonPreview.vue';
import GfToggle from '@/core/components/base/GfToggle.vue';
import TextAdvancedSetting from './/TextAdvancedSetting.vue';
import HELPER from '@/app/utils/HELPER';
import { cloneDeep } from '@/utils/common';
import { actions, mutations } from '@modules/editor-sidebar';
import type { PresetOptionParams } from '@/types/global-style-http';
import type { PresetOptionType } from '@/types/global-style';
import { presetOptionTypes, dropPresetValueStyle } from '../../constants/styleConstant';
import ButtonMixin from '../../utils/mixins/Button';
import { COLOR_KEYS_MAP } from '@/constants/global-style';
import ColorItem from '@/core/components/base/color/ColorItem.vue';

const BUTTON_STYLE = [
  { name: 'Icon & Text', value: 'icon_text' },
  { name: 'Icon Only', value: 'icon' },
  { name: 'Text Only', value: 'text' },
];

export default defineComponent({
  name: 'ButtonPanel',
  components: {
    GfDropdown,
    GfSegment,
    GfToggle,
    ButtonPreview,
    TextAdvancedSetting,
    ColorItem,
  },
  mixins: [ButtonMixin],
  props: {
    buttonItem: {
      type: Object,
      default: () => ({}),
    },
    indexItem: { type: Number, default: -1 },
    positionTopPreviewButton: { type: Number, default: 0 },
    isReadyToSave: { type: Boolean, default: true },
  },
  data: (): {
    button: any;
    isOpenTooltip: boolean;
    iconPositionActive: 0 | 1;
    showColorPalette: boolean;
    showColorPickerDropShadow: boolean;
    styleColorPicker: any;
    targetPalette: string;
    targetType: string;
    isSettingDropshadow: boolean;
    degInputUnit: any;
    pxInputUnit: any;
    BUTTON_STYLE: any;
    isOpenIconPicker: boolean;
    borders: any;
    corners: any;
    textStyles: any;
    selectedTextStyle: any;
    styleTextStyleSetting: any;
    presetTextClone: any;
    isShowAdvanceSetting: any;
    styleButtonPreview: any;
    widthTooltip: any;
    selectedColor: any;
  } => ({
    button: {},
    iconPositionActive: 0, // 0 = Before, 1 = After
    showColorPalette: false,
    showColorPickerDropShadow: false,
    styleColorPicker: {},
    targetPalette: '',
    targetType: '',
    isSettingDropshadow: false,
    degInputUnit: [
      {
        name: 'deg',
        value: 'deg',
      },
    ],
    pxInputUnit: [
      {
        name: 'px',
        value: 'px',
      },
    ],
    BUTTON_STYLE,
    isOpenIconPicker: false,
    borders: [],
    corners: [],
    textStyles: [],
    selectedTextStyle: null,
    styleTextStyleSetting: {},
    isOpenTooltip: false,
    presetTextClone: {},
    isShowAdvanceSetting: false,
    styleButtonPreview: {},
    widthTooltip: 'auto',
    selectedColor: '',
  }),
  computed: {
    ...mapState('sidebar', {
      currentPreset: (state: any) => state.currentPreset,
    }),
    styleColorPalette() {
      if ((this as any).targetType === 'text') {
        return {
          top: (this as any).positionColorPalette.text,
        };
      } else if ((this as any).targetType === 'icon') {
        return {
          top: (this as any).positionColorPalette.icon,
        };
      } else {
        return {
          top: (this as any).positionColorPalette.background,
        };
      }
    },
    displayIcon() {
      return HELPER.base64UrlDecode((this as any).button.value.icon);
    },
    isUseVarianIcon() {
      const buttonStyle = (this as any).button.value.buttonStyle;
      return buttonStyle === (this as any).ICON_TEXT_BUTTON || buttonStyle === (this as any).ICON_BUTTON;
    },
    isUseVarianTextIcon() {
      const buttonStyle = (this as any).button.value.buttonStyle;
      return buttonStyle === (this as any).ICON_TEXT_BUTTON;
    },
    isUseVarianOnlyIcon() {
      const buttonStyle = (this as any).button.value.buttonStyle;
      return buttonStyle === (this as any).ICON_BUTTON;
    },
    isUseVarianOnlyText() {
      const buttonStyle = (this as any).button.value.buttonStyle;
      return buttonStyle === (this as any).TEXT_BUTTON || buttonStyle === (this as any).ICON_TEXT_BUTTON;
    },
    positionColorPalette() {
      const position: any = {};
      if ((this as any).isUseVarianTextIcon) {
        position.text = '75px';
        position.icon = '160px';
        position.background = '235px';
      } else if ((this as any).isUseVarianOnlyText) {
        position.text = '75px';
        position.background = '160px';
      } else if ((this as any).isUseVarianOnlyIcon) {
        position.icon = '75px';
        position.background = '160px';
      }
      return position;
    },
    isScrollDropdown() {
      return true;
    },
  },
  watch: {
    'button.value.buttonStyle'(val) {
      if (val == this.ICON_TEXT_BUTTON && !this.button.value.iconPosition) {
        this.button.value.iconPosition = 'before';
      }
      if (val == this.ICON_TEXT_BUTTON || val == this.ICON_BUTTON) {
        if (!this.button.value.iconColor) this.button.value.iconColor = {};
        if (!this.button.value.iconColor.origin)
          this.button.value.iconColor.origin = `var(--${COLOR_KEYS_MAP['neutral-color1']})`;
        if (!this.button.value.iconColor.hover)
          this.button.value.iconColor.hover = `var(--${COLOR_KEYS_MAP['neutral-color1']})`;
        const defaultIcon = 'fa-500px';
        if (!this.button.value.icon)
          this.button.value.icon = HELPER.base64UrlEncode(`<i class="gf_icon fa ${defaultIcon}"></i>`);
      }
      if (val == this.ICON_TEXT_BUTTON || val == this.TEXT_BUTTON) {
        if (!this.button.value.textColor) this.button.value.textColor = {};
        if (!this.button.value.textColor.origin)
          this.button.value.textColor.origin = `var(--${COLOR_KEYS_MAP['neutral-color1']})`;
        if (!this.button.value.textColor.hover)
          this.button.value.textColor.hover = `var(--${COLOR_KEYS_MAP['neutral-color1']})`;
      }
    },
    positionTopPreviewButton(val) {
      this.$nextTick(() => {
        let top = val;
        if (val + 100 + (this as any).$refs?.previewButton?.$el.clientHeight > window.innerHeight) {
          top = window.innerHeight - (this as any).$refs?.previewButton?.$el.clientHeight - 120;
        } else if (val < 0) {
          top = 100;
        }
        this.styleButtonPreview = {
          top: top + 'px',
        };
      });
    },
    buttonItem: {
      handler(val) {
        this.button = { ...val };
      },
      deep: true,
    },
  },
  created() {
    this.button = { ...this.buttonItem };
    if (!this.IS_SETTING_ICON_IN_BUTTON) {
      this.button.value.buttonStyle = 'text';
    }
    const DEFAULT_OPTIONS = [
      {
        name: 'None',
        value: null,
      },
    ];
    this.borders = DEFAULT_OPTIONS.concat(
      this.presetBorders.map((border: { name: any; id: any }) => {
        return {
          name: border.name,
          value: border.id,
          handleEdit: true,
          tooltipEdit: 'Edit Border',
        };
      }),
    );
    this.corners = DEFAULT_OPTIONS.concat(
      this.presetConners.map((corner: { name: any; id: any }) => {
        return {
          name: corner.name,
          value: corner.id,
          handleEdit: true,
          tooltipEdit: 'Edit Corner',
        };
      }),
    );
    this.getTextStyle();
    this.presetTextClone = this.presetTexts;
  },
  methods: {
    ...mapActions('sidebar', {
      savePresetOptions: actions.SAVE_PRESET_OPTIONS,
    }),
    ...mapMutations('sidebar', {
      setCurrentPresetOptions: mutations.SET_CURRENT_PRESET_OPTIONS,
      setCurrentPreset: mutations.SET_CURRENT_PRESET,
      setPresetToPresetList: mutations.SET_PERSET_TO_PRESET_LIST,
      stepPreset: mutations.SET_STEP_PRESET,
      setComponentTargetGS: mutations.SET_COMPONENT_TARGET_GLOBAL_STYLE,
      setStyleIdTargetGS: mutations.SET_STYLE_ID_TARGET_GLOBAL_STYLE,
    }),
    getTextStyle() {
      this.textStyles = [];
      this.presetTexts.forEach((text: { key: string | string[]; id: any; name: any }) => {
        if (text.key.includes('heading') || text.key.includes('paragraph')) {
          this.textStyles.push({
            value: text.key,
            name: text.name,
            handleEdit: true,
          });
        }
      });
    },
    onSelectIconPosition(data: any) {
      this.button.value.iconPosition = data.value;
    },
    onShowColorPalette(type: any, target: any) {
      if (this.showColorPalette && this.targetType === type && this.targetPalette === target) {
        this.showColorPalette = false;
        return false;
      }
      this.showColorPalette = true;
      this.targetType = type;
      this.targetPalette = target;
      switch (this.targetPalette) {
        case 'text_origin':
          this.selectedColor = this.button.value.textColor.origin;
          break;
        case 'text_hover':
          this.selectedColor = this.button.value.textColor.hover;
          break;
        case 'icon_origin':
          this.selectedColor = this.button.value.iconColor.origin;
          break;
        case 'icon_hover':
          this.selectedColor = this.button.value.iconColor.hover;
          break;
        case 'background_origin':
          this.selectedColor = this.button.value.backgroundColor.origin;
          break;
        case 'background_hover':
          this.selectedColor = this.button.value.backgroundColor.hover;
          break;
        default:
          break;
      }
      return false;
    },
    isCurrentChangeColor(type: any, target: any) {
      return this.showColorPalette && this.targetType === type && this.targetPalette === target;
    },
    onCloseColorPalette() {
      // TODO
      // setTimeout(() => {
      // this.showColorPalette = false;
      // this.targetType = "";
      // this.targetPalette = "";
      // }, 100);
      return false;
    },
    onShowColorPickerDropShadow() {
      this.showColorPickerDropShadow = !this.showColorPickerDropShadow;
    },
    onCancelColorPicker() {
      this.showColorPickerDropShadow = false;
    },
    onApplyColorPicker(color: { rgba: any }) {
      this.button.value.dropShadow['color'] = HELPER.rgbToFullHex(color.rgba);
    },
    onCancelColorPalette() {
      this.showColorPalette = false;
    },
    onApplyColorPalette(color: any) {
      this.handlePickColorPalette(color);
      this.showColorPalette = false;
    },
    handlePickColorPalette(color: { name: any }) {
      const valueStyleColor = `var(--${COLOR_KEYS_MAP[color.name]})`;
      const buttonNew = this.button;
      switch (this.targetPalette) {
        case 'text_origin':
          buttonNew.value.textColor.origin = valueStyleColor;
          break;
        case 'text_hover':
          buttonNew.value.textColor.hover = valueStyleColor;
          break;
        case 'icon_origin':
          if (buttonNew.value.iconColor) {
            buttonNew.value.iconColor.origin = valueStyleColor;
          } else {
            buttonNew.value.iconColor = {
              origin: valueStyleColor,
            };
          }
          break;
        case 'icon_hover':
          if (buttonNew.value.iconColor) {
            buttonNew.value.iconColor.hover = valueStyleColor;
          } else {
            buttonNew.value.iconColor = {
              hover: valueStyleColor,
            };
          }
          break;
        case 'background_origin':
          buttonNew.value.backgroundColor.origin = valueStyleColor;
          break;
        case 'background_hover':
          buttonNew.value.backgroundColor.hover = valueStyleColor;
          break;
        default:
          break;
      }
    },
    getBackgroundColorPresetOptions(key: string | number) {
      return this.presetColors[key];
    },
    toggleSettingDropshadow(value: any) {
      this.button.value.dropShadow['enabled'] = value;
      const dropshadowValue = this.button.value.dropShadow;
      if (
        dropshadowValue.enabled &&
        !dropshadowValue.angle &&
        !dropshadowValue.distance &&
        !dropshadowValue.blur &&
        !dropshadowValue.size
      ) {
        this.button.value['dropShadow'] = {
          enabled: true,
          angle: '0deg',
          distance: '4px',
          blur: '30px',
          size: '0px',
          color: '',
        };
      }
    },
    onToggleIconPicker() {
      this.isOpenIconPicker = !this.isOpenIconPicker;
    },
    onSelectIcon(icon: string) {
      this.isOpenIconPicker = false;
      if (icon) {
        const iconTag = '<i class="gf_icon fa ' + icon + '"></i>';
        const buttonNew = cloneDeep(this.button);
        buttonNew.value.icon = HELPER.base64UrlEncode(iconTag);
        this.button = buttonNew;
      }
      return;
    },
    onSelectBorderStyle(e: { value: any }) {
      this.button.value.borderStyle = e.value;
    },
    onSelectCornerStyle(e: { value: any }) {
      this.button.value.cornerStyle = e.value;
    },
    onSelectTextStyle(e: { value: any }, type: any) {
      this.button.value.textStyle[`${type}`] = e.value;
    },
    getValueWithDataUnit(data: string) {
      if (!data) {
        return {
          value: '',
          unit: '',
        };
      }
      const result: any = data.match(/[a-z]+|[^a-z]+/gi);
      return {
        value: parseFloat(result[0]),
        unit: result[1],
      };
    },
    onChangeDistanceDropshadow(e: { value: any; unit: any }) {
      this.button.value.dropShadow['distance'] = e.value + e.unit;
    },
    onChangeBlurDropshadow(e: { value: any; unit: any }) {
      this.button.value.dropShadow['blur'] = e.value + e.unit;
    },
    onChangeAngleDropshadow(e: { value: any; unit: any }) {
      this.button.value.dropShadow['angle'] = e.value + e.unit;
    },
    onChangeSizeDropshadow(e: { value: any; unit: any }) {
      this.button.value.dropShadow['size'] = e.value + e.unit;
    },
    onHandleEditTextStyle(e: { $event: any; option: { value: any } }) {
      const key = e.option.value;
      const text = this.presetTexts.find((item: { key: any }) => item.key === key);
      this.setStepPreset(dropPresetValueStyle.textStyle, text.id);
    },
    onHandleEditBorderStyle(e: { $event: any; option: { value: any } }) {
      this.setStepPreset(dropPresetValueStyle.borderStyle, e.option.value);
    },
    onHandleEditCornerStyle(e: { $event: any; option: { value: any } }) {
      this.setStepPreset(dropPresetValueStyle.cornerStyle, e.option.value);
    },
    setStepPreset(style: any, targetId: any) {
      if (!this.isReadyToSave) {
        return;
      }
      this.stepPreset({
        next: {
          type: style,
          target: targetId,
        },
        prev: {
          type: dropPresetValueStyle.buttonStyle,
          target: this.buttonItem.id,
        },
      });
    },
    textAdvanceClickAway() {
      this.isShowAdvanceSetting = false;
    },
    onChangTextItem(data: any) {
      const indexPreset = this.presetTextClone.findIndex((item: { key: any }) => item.key === data.key);
      if (indexPreset !== -1) {
        this.presetTextClone[indexPreset].value = data.text;
      }
      this.button.onchange = Date.now();
      this.button = cloneDeep(this.button);
      return false;
    },
    onCloseAdvancedSetting() {
      this.isShowAdvanceSetting = false;
      this.selectedTextStyle = null;
      this.handleSaveData();
    },
    async handleSaveData(): Promise<any> {
      const presetOptions = this.presetTextClone;
      const params: PresetOptionParams = {
        presetId: this.currentPreset.id as number,
        type: presetOptionTypes.text as PresetOptionType,
        destroy: this.currentPreset.destroy as boolean,
        presetOptions: presetOptions,
        cssStr: '' as string,
      };
      return this.savePresetOptions(params).then((response: any) => {
        setTimeout(() => {
          const newPreset = cloneDeep(this.currentPreset);
          newPreset.presetOptions.texts = response.presetOptions.texts;
          this.button.onchange = Date.now();
          this.presetTextClone = this.presetTexts;
          this.setCurrentPreset(newPreset);
          this.setPresetToPresetList(newPreset);
          this.getTextStyle();
        }, 200);
      });
    },
    onEditColorStyle() {
      this.stepPreset({
        next: {
          type: dropPresetValueStyle.colorStyle,
          target: {},
        },
        prev: {
          type: dropPresetValueStyle.buttonStyle,
          target: this.buttonItem,
        },
      });
    },
    getBackgroundColor(color: any) {
      if (!color || color.includes('transparent')) {
        return '';
      }
      return color;
    },
  },
});
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.wap-edit-panel {
  border: 1px solid map-get($primary-blue, '250');
  border-radius: $radius;
  -moz-border-radius: $radius;
  -webkit-border-radius: $radius;
  margin-bottom: 8px;
  min-height: 300px;

  // eslint-disable-next-line vue-scoped-css/no-unused-selector
  .wrap-head {
    background: map-get($hybrid-shade-dark, '200');
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    padding: 8px;
    justify-content: space-between;

    // eslint-disable-next-line vue-scoped-css/no-unused-selector
    .panel-title {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
    }

    // eslint-disable-next-line vue-scoped-css/no-unused-selector
    .icon-arrow-down {
      cursor: pointer;
    }
  }

  .row-wrapper {
    flex-basis: auto;
    padding: 8px 8px 0;
    color: map-get($text-dark-mode, 'low-contrast');

    .gf_panel__wrap-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      min-height: 32px;

      .fix-icon-left {
        flex: 0 0 40% !important;
      }

      .fix-icon-right {
        flex: 0 0 60% !important;
      }

      .setting-left {
        justify-content: flex-start;
        display: flex;
        align-items: center;

        .text-style-format {
          display: flex;
          margin-bottom: 8px;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 500;
          font-size: 11px;
          line-height: 14px;
        }
      }

      .setting-right {
        flex: 0 0 50%;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        :deep(.btn-dropdown-class) {
          width: 120px;
          border: 1px solid map-get($hybrid-shade-dark, '200');
          background-color: inherit;
        }

        :deep(.gf_dropdown--options) {
          min-width: 140px;
          max-width: 180px;
        }

        .wrap-icon-setting {
          background: map-get($hybrid-shade-dark, '200');
          border-radius: $radius;
          -moz-border-radius: $radius;
          -webkit-border-radius: $radius;
          width: 32px;
          height: 32px;
          position: relative;
          cursor: pointer;
          border: 1px solid map-get($hybrid-shade-dark, '200');
          display: flex;
          justify-content: center;
          align-items: center;

          .icon-selected {
            margin-left: auto;
            margin-right: auto;
          }
          :deep(i) {
            font-size: 18px;
          }
        }

        .wrap-icon-radio {
          display: flex;
          border: 1px solid map-get($hybrid-shade-dark, '200');
          border-radius: $radius;
          :deep(.gf_segment) {
            background: #000;
            .gf_segment__label {
              font-family: 'Inter';
              font-style: normal;
              font-weight: 700;
              font-size: 11px;
              line-height: 14px;
            }
            .gf_segment__button {
              padding: 9px 8px;
            }
          }

          // eslint-disable-next-line vue-scoped-css/no-unused-selector
          .icon-position {
            width: 10px;
            height: 10px;
            background: map-get($text-dark-mode, 'high-contrast');
            border-radius: 50%;
          }

          // eslint-disable-next-line vue-scoped-css/no-unused-selector
          .before-icon {
            flex: 1 1 auto;
            display: flex;
            padding: 9px 6px;
            align-items: center;
            border-right: 1px solid map-get($hybrid-shade-dark, '200');
            font-size: 11px;
            cursor: pointer;

            // eslint-disable-next-line vue-scoped-css/no-unused-selector
            .icon-position {
              margin-right: 8px;
            }
          }

          // eslint-disable-next-line vue-scoped-css/no-unused-selector
          .after-icon {
            flex: 1 1 auto;
            display: flex;
            padding: 9px 6px;
            align-items: center;
            cursor: pointer;

            // eslint-disable-next-line vue-scoped-css/no-unused-selector
            .icon-position {
              margin-left: 8px;
            }
          }

          // eslint-disable-next-line vue-scoped-css/no-unused-selector
          .active {
            background: map-get($hybrid-shade-dark, '200');
          }

          // eslint-disable-next-line vue-scoped-css/no-unused-selector
          .input-radio {
            border: 0;
          }

          // eslint-disable-next-line vue-scoped-css/no-unused-selector
          .div-radio {
            padding-bottom: 0;
            font-weight: 700;
            font-size: 11px;
            line-height: 14px;
            color: #ffffff;
          }
        }

        // eslint-disable-next-line vue-scoped-css/no-unused-selector
        .switch {
          position: relative;
          display: inline-block;
          width: 38px;
          padding-bottom: 0;

          // eslint-disable-next-line vue-scoped-css/no-unused-selector
          .inp {
            opacity: 0;
            width: 0;
            height: 0;

            // eslint-disable-next-line vue-scoped-css/no-unused-selector
            &:checked + .slider {
              background-color: #3c67ff;
            }

            // eslint-disable-next-line vue-scoped-css/no-unused-selector
            &:focus + .slider {
              box-shadow: 0 0 1px #3c67ff;
            }

            // eslint-disable-next-line vue-scoped-css/no-unused-selector
            &:checked + .slider:before {
              -webkit-transform: translateX(18px);
              -ms-transform: translateX(18px);
              transform: translateX(18px);
            }
          }

          // eslint-disable-next-line vue-scoped-css/no-unused-selector
          .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: map-get($hybrid-shade-dark, '200');
            -webkit-transition: 0.4s;
            transition: 0.4s;
            width: 38px;
            height: 20px;

            &:before {
              position: absolute;
              content: '';
              height: 18px;
              width: 18px;
              left: 1px;
              bottom: 1px;
              background-color: #fff;
              -webkit-transition: 0.4s;
              transition: 0.4s;
            }
          }

          /* Rounded sliders */
          // eslint-disable-next-line vue-scoped-css/no-unused-selector
          .slider.round {
            border-radius: 34px;

            &:before {
              border-radius: 50%;
            }
          }
        }
      }

      .box-icon-picker {
        position: relative;

        .icon-picker {
          position: absolute;
          top: 35px;
          z-index: 1;
        }
      }

      .wrap-text-style {
        font-size: 11px;
        background: map-get($hybrid-shade-dark, '300');
        border-radius: $radius;
        -moz-border-radius: $radius;
        -webkit-border-radius: $radius;
        padding: 8px 16px 0;

        :deep(.btn-dropdown-class) {
          width: 120px;
          border: 1px solid map-get($hybrid-shade-dark, '200');
          background-color: inherit;
        }

        :deep(.gf_dropdown--options) {
          width: 180px;
        }

        .gf_panel__wrap-row {
          display: flex;
          justify-content: space-between;

          .left-col {
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }

          .right-col {
            justify-content: flex-end;
            display: flex;
          }
        }
      }
    }
    .setting-dropshadow {
      font-size: 11px;
      padding: 8px 16px;
      background-color: map-get($hybrid-shade-dark, '300');
      border-radius: $radius;
      @media screen and (max-width: 1300px) {
        padding: 8px 4px;
      }
      &--distance {
        display: flex;
        margin-bottom: 12px;
      }

      &_item-color {
        position: relative;
        width: 83px;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;

        :deep(.color--picker) {
          left: -17px;
          position: absolute;
          z-index: 10;
          top: 35px;
        }

        .demo-color-picker {
          background: url('/editor/static/icons/transparent-color.svg');
          background-size: cover;
          cursor: pointer;
          width: 30px;
          height: 30px;
          border: 1px solid map-get($hybrid-shade-dark, '200');
          border-radius: $radius;
          -moz-border-radius: $radius;
          -webkit-border-radius: $radius;

          &--box {
            width: 100%;
            height: 100%;
            border-radius: $radius;
          }
        }
      }

      // eslint-disable-next-line vue-scoped-css/no-unused-selector
      &_item {
        &--first {
          width: 117px;
        }
        &--second {
          width: 93px;
        }
      }

      &_input {
        width: 66px;
      }

      :deep(.setting-dropshadow_input--unit-class) {
        padding: 8px 8px 8px 4px;
      }
    }

    .wrap-pack-color {
      position: relative;
      .gf_panel__wrap-row {
        background: map-get($hybrid-shade-dark, '300');
        display: flex;
        padding: 8px 16px;
        border-radius: $radius;

        .left {
          flex: 0 0 50%;
          display: flex;
          justify-content: flex-start;
        }

        .right {
          flex: 0 0 50%;
          display: flex;
          justify-content: flex-end;
        }

        .wrap-choose-color {
          display: flex;

          .color-col-left {
            flex: 0 0 50%;
            display: flex;
            align-items: center;
            padding-right: 16px;

            .lbl {
              padding-bottom: 0;
            }
          }

          .color-col-right {
            flex: 0 0 50%;

            .demo-color-picker {
              cursor: pointer;
              width: 30px;
              height: 30px;
              border: 1px solid map-get($hybrid-shade-dark, '200');
              border-radius: $radius;
              -moz-border-radius: $radius;
              -webkit-border-radius: $radius;
              background-image: url('/editor/static/icons/transparent-color.svg');
              background-size: cover;

              &--box {
                width: 100%;
                height: 100%;
                border-radius: $radius;
              }
            }
          }
        }
        .title-pack-color {
          margin-bottom: 8px;
        }
      }
    }

    .flex-row {
      flex-direction: column !important;
    }
  }

  .color--palette {
    position: absolute;
    top: 17%;
    left: 8px;
    z-index: 9;
  }
  .gf_panel-position {
    :deep(.gf_segment__group-button) {
      padding: 7px 8px;
    }
  }
}
</style>
